import React from 'react'
import { useT } from '../i18n'

import footer_logo from '../assets/images/kanosei/footer__logo.png'
 
const Footer = () => {
        const { t } = useT();
        return(
            <>
                <footer>
                    <div className="footer__bottom">
                        <div className="wrapper">
                            <div className="footer__bottom_inner">
                                <a href="/" className="footer__logo"><img src={`${footer_logo}`} alt=""/></a>
                                <div className="right__box">
                                    {/* A plain mailto, not a form. The X account
                                        is not managed and the contact form sent
                                        to an inbox nobody reads — a channel that
                                        is not answered is worse than none. */}
                                    <a className="footer__email" href="mailto:info@kanosei.xyz">
                                        info@kanosei.xyz
                                    </a>
                                    {/* Derived, not hardcoded: the literal said
                                        2024 two years running. */}
                                    <span className="copyright">
                                        {t('footer.rights', { year: new Date().getFullYear() })}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        )
}

export default Footer;